import React, { useEffect, useState } from 'react';
import { FaBagShopping } from "react-icons/fa6";
import { FaBed } from "react-icons/fa";
import { IoRestaurantSharp } from "react-icons/io5";
import { FaGlassMartini } from "react-icons/fa";
import { IoGridOutline } from "react-icons/io5";
import { MdArrowRightAlt } from "react-icons/md";
import shop_1 from '../assets/images/shop_1.jpg';
import Appdownload from './Appdownload';
import { MdSupportAgent, MdLocationOn, MdEmail, MdPhone } from 'react-icons/md';
import { BiSend, BiCheckDouble } from 'react-icons/bi';
import { HiOutlineChatAlt2 } from 'react-icons/hi';
import { webDetails, serviceCategory } from '../api/api';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCommentDots,
  FaRobot,
  FaHeadset,
  FaQuestionCircle,
  FaHome,
  FaPaperPlane,
  FaCheckCircle,
  FaExclamationCircle
} from 'react-icons/fa';
import Homeslider from './HeroSlider';
import HowItWorks from './HowItWorks';
function Home() {

  const [webData, setWebData] = useState(null);
  const [servCat, serviCateg] = useState(null);
  const slideUrl = "https://cricketapi.sindoor7.com/";


  useEffect(() => {
    webDetails()
      .then((res) => {
        setWebData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    serviceCategory()
      .then((res) => {
        serviCateg(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Homeslider />

      {/* /main_categories */}
      {servCat && servCat.map((cat) => (
        <div className="container margin_60_35" key={cat._id}>

          <div className="main_title_3 d-flex justify-content-between align-items-center margin-bottom-30">
            <h2>{cat.title}</h2>
            <a href="#" className='seeall position-relative d-flex gap-2 align-items-center'>
              See all <MdArrowRightAlt />
            </a>
          </div>

          <div className="row add_bottom_30  gap-new-all">

            {cat.subcategories && cat.subcategories.map((sub) => (
              <div className="col-lg-3 col-sm-6" key={sub._id}>
                <a href="" className="grid_item small">
                  <figure>
                    <img
                      src={`${slideUrl}${sub.image}`}
                      alt={sub.title}
                    />
                    <div className="info">
                      <h3>{sub.title}</h3>
                    </div>
                  </figure>
                </a>
              </div>
            ))}

          </div>
        </div>
      ))}

      <HowItWorks />
      <Appdownload />
      <div className="contact-section" id='contact'>
        <div className="container">
          <div className="main_title_2">
            <span><em /></span>
            <h2>Contact Us</h2>
            <p>Have questions? We'd love to hear from you. Get in touch with our team.</p>
          </div>

          <div className="contact-grid">
            {/* Need Help Card */}
            <div className="contact-card">
              <div className="contact-card-icon">
                <MdSupportAgent />
              </div>
              <h3 className="contact-card-title">Need Help?</h3>
              <p className="contact-card-desc">Our support team is available 24/7 to assist you</p>
              <div className="contact-card-details">
                {webData?.phone && (
                  <a href={`tel:+91${webData.phone}`} className="contact-link">
                    <MdPhone /> +91 {webData.phone}
                  </a>
                )}
                {webData?.email && (
                  <a href={`mailto:${webData.email}`} className="contact-link">
                    <MdEmail /> {webData.email}
                  </a>
                )}
              </div>
            </div>

            {/* Questions Card */}
            {/* <div className="contact-card active_new">
                <div className="contact-card-icon">
                    <FaQuestionCircle />
                </div>
                <h3 className="contact-card-title">Questions?</h3>
                <p className="contact-card-desc">Got questions about our services? We're here to help</p>
                <div className="contact-card-details">
                    <a href="tel:+433243242322" className="contact-link">
                        <MdPhone /> +43 324242322
                    </a>
                    <a href="mailto:info@sparker.com" className="contact-link">
                        <MdEmail /> info@sparker.com
                    </a>
                </div>
            </div> */}

            {/* Address Card */}
            <div className="contact-card">
              <div className="contact-card-icon">
                <FaHome />
              </div>
              <h3 className="contact-card-title">Our Location</h3>
              <p className="contact-card-desc">Visit us at our headquarters</p>
              <div className="contact-card-details">
                <p className="address-text">
                  <MdLocationOn />
                  {webData?.address && (
                    <span>
                      {webData.address}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Appnew/> */}
      {/* /container */}
    </>

  )
}

export default Home
